// Anglais — Socle : menu, états, rôles, unités, erreurs, composants partagés.
// Clé : le texte français exact de l'interface (voir lib/i18n.ts).
export const common: Record<string, string> = {
  "o": "B",
  "ko": "kB",
  "Mo": "MB",
  "Go": "GB",
  "To": "TB",
  "{d} j {h} h": "{d} d {h} h",
  "En ligne": "Online",
  "Dégradé": "Degraded",
  "Pas de signal": "No signal",
  "Désactivée": "Disabled",
  "Arrêtée": "Stopped",
  "Attente source": "Waiting for source",
  "Démarrage": "Starting",
  "En service": "Running",
  "En relance": "Retrying",
  "État inconnu": "Unknown state",
  "Lecture seule": "Read-only",
  "Opérateur": "Operator",
  "Administrateur": "Administrator",
  "Client": "Client",
  "Voit les flux, l'état et le journal. Clés et mots de passe masqués.": "Sees streams, status and the event log. Keys and passwords hidden.",
  "Démarre et arrête les sorties, change leur source, déconnecte un encodeur.": "Starts and stops outputs, switches their source, disconnects an encoder.",
  "Crée et supprime entrées et sorties, gère les comptes.": "Creates and deletes inputs and outputs, manages accounts.",
  "Client extérieur : ne voit et ne gère que ses propres entrées et sorties, dans ses limites.": "External client: sees and manages only their own inputs and outputs, within their limits.",
  "Identifiant": "Username",
  "Nom": "Name",
  "Mode": "Mode",
  "Protocole": "Protocol",
  "URL source": "Source URL",
  "Clé de flux": "Stream key",
  "Passphrase SRT": "SRT passphrase",
  "Source": "Source",
  "URL": "URL",
  "Débit vidéo": "Video bitrate",
  "Débit audio": "Audio bitrate",
  "Mot de passe": "Password",
  "Nouveau mot de passe": "New password",
  "Rôle": "Role",
  "valeur invalide": "invalid value",
  "{label} : {msg}": "{label}: {msg}",
  "Vos droits ne permettent pas cette action.": "Your permissions do not allow this action.",
  "ServerMedia ne répond pas.": "ServerMedia is not responding.",
  "Erreur {status}": "Error {status}",
  "Le serveur ne répond pas.": "The server is not responding.",
  "Fermer": "Close",
  "Annuler": "Cancel",
  "Copier": "Copy",
  "Copié": "Copied",
  "{title}, de {from} à {to}": "{title}, from {from} to {to}",
  "Pas encore de mesures sur cette période.": "No measurements yet for this period.",
  "Tableau de bord": "Dashboard",
  "Entrées": "Inputs",
  "Sorties": "Outputs",
  "Matrice": "Matrix",
  "Journal": "Event log",
  "Comptes": "Users",
  "Demandes": "Requests",
  "Réglages": "Settings",
  "Temps réel": "Live",
  "Connexion…": "Connecting…",
  "Hors ligne, reconnexion…": "Offline, reconnecting…",
  "ServerMedia injoignable": "ServerMedia unreachable",
  "Aucune alarme": "No alarms",
  "1 alarme": "1 alarm",
  "{n} alarmes": "{n} alarms",
  "Langue non enregistrée sur le compte": "Language not saved to the account",
  "Connecté :": "Signed in:",
  "Langue": "Language",
  "active": "on",
  "inactive": "off",
  "Navigation": "Navigation",
  "Réservé aux administrateurs": "Administrators only",
  "Retour au tableau de bord": "Back to the dashboard",
  "Le serveur de la gateway ne répond pas. Nouvel essai en cours…": "The gateway server is not responding. Retrying…",
  "Connexion à la gateway…": "Connecting to the gateway…",
  "Le serveur de la gateway ne répond pas. Rechargez la page dans un instant.": "The gateway server is not responding. Reload the page in a moment.",
  "Identifiant de l'entrée": "Input ID",
  "Code": "Code",
  "Nom de famille": "Last name",
  "Société": "Company",
  "Adresse à prévenir": "Address to notify",
  "Dossier": "Folder",
  "Horaires (français)": "Hours (French)",
  "Horaires (anglais)": "Hours (English)",
};
